import gql from 'graphql-tag';

export default gql`
mutation AppApprove(
        $uuid: String!
      ) {
    appApprove(uuid: $uuid) {
      __typename
    }
}
`;
